<div class="router-outlet" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="isLoading"
    size="small"
    [disableAnimation]="false"
    name="pacingPlanDayViewSpinner"
    color="white"
    name="pacingPlanDayViewSpinner"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="1003"
  >
    {{ loadingText }}
  </ngx-spinner>
  <div class="row" *ngIf="classroom">
    <div class="col-md-12 d-flex justify-content-center">
      <nb-card class="classroom-details">
        <nb-card-body>
          <div class="d-flex justify-content-between">
            <div class="classroom-name-content text-left">
              <h5 class="classroom-name quicksand-bold-label">
                {{ classroom?.name }}
              </h5>

              <div class="classroom-subject quicksand-bold-label">
                {{ classroom?.subject | uppercase }}
              </div>
            </div>

            <div class="d-flex" style="margin-right: -5px">
              <div class="classroom-code text-center quicksand-bold-label">
                {{ classroom?.code }}
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

      <div class="btn-close-content">
        <button class="btn-close" (click)="back()" *ngIf="isBack">
          <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="row day-view">
    <div class="col-md-4 d-flex">
      <button
        mwlCalendarPreviousView
        [view]="calendarViewType"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
        class="navigate-btn one"
        aria-label="Example icon button with a home icon"
        (click)="getCurrentPacingPlanToShow(); getLessonPlanEvents(true)"
        [disabled]="isStart"
      >
        <mat-icon class="navigate-icon">navigate_before</mat-icon>
      </button>
      <button
        mwlCalendarToday
        [(viewDate)]="viewDate"
        class="today-btn"
        aria-label="Example icon button with a home icon"
        (click)="getCurrentPacingPlanToShow(); getLessonPlanEvents(true)"
      >
        Today
      </button>
      <button
        mwlCalendarNextView
        [view]="calendarViewType"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
        class="navigate-btn two"
        aria-label="Example icon button with a home icon"
        [disabled]="isEnd"
        (click)="getCurrentPacingPlanToShow(); getLessonPlanEvents(true)"
      >
        <mat-icon class="navigate-icon">navigate_next</mat-icon>
      </button>
    </div>

    <div *ngIf="currentCalendar && currentCalendar.length > 0" class="col-md-4 text-center">
      <h5 *ngIf="calendarViewType" class="calendar-date">
        {{ viewDate | calendarDate : calendarViewType + 'ViewTitle' : 'en' }}
      </h5>
      <label class="lesson-plan-label-content">You can update lesson plan in Day view by clicking on lesson plan</label>
    </div>

    <div class="col-md-4 text-right events-content">
      <div class="add-pacing-plan-content" *ngIf="!teacherId">
        <ng-container *ngIf="testAndReviewDay && testAndReviewDay.length === 0">
          <ng-container *ngIf="currentShowPacingPlan && currentShowPacingPlan.length > 0">
            <button
              mat-raised-button
              aria-label="Example icon button with a home icon"
              class="add-lesson-plan"
              (click)="lessonPlanEventClicked(null, false, true)"
              *ngIf="isShowLessonPlans"
            >
              <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
              Add Lesson Plan
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <br />

  <div>
    <div [ngSwitch]="calendarViewType">
      <div *ngIf="isView">
        <div class="d-flex select-bar-content mb-2" [ngClass]="currentShowPacingPlan.length > 0 ? 'section-title' : ''">
          <ng-container *ngIf="testAndReviewDay && testAndReviewDay.length === 0">
            <div *ngIf="currentShowPacingPlan && currentShowPacingPlan.length > 0">
              <table class="table w-100">
                <thead class="table-heading">
                  <tr>
                    <th class="day-event-label quicksand-normal-label py-2 align-middle col-xl-1 col-xll-1 col-md-2 col-sm-2">
                      Section Id
                    </th>
                    <th class="day-event-label quicksand-normal-label py-2 align-middle col-xl-11 col-xll-11 col-md-10 col-sm-10">
                      Section Title
                    </th>
                  </tr>
                </thead>
                <tbody class="section-content">
                  <tr *ngFor="let item of currentShowPacingPlan">
                    <td class="quicksand-normal-label event-label-values border-0 text-wrap py-2">
                      {{ item?.section_id ? item?.section_id : '-' }}
                    </td>
                    <td class="quicksand-normal-label event-label-values border-0 text-wrap py-2">
                      {{ item.section_title ? item.section_title : '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <ng-container *ngIf="dayEvent && dayEvent.cssClass">
            <h6 class="mt-4 quicksand-bold-label">
              {{ dayEvent?.title }}
            </h6>
          </ng-container>

          <ng-container *ngIf="testAndReviewDay && testAndReviewDay.length > 0">
            <h6 class="mt-4 quicksand-bold-label">
              {{ testAndReviewDay[0]?.type }}
            </h6>
          </ng-container>
        </div>
        <mwl-calendar-day-view
          class="calendar-week-view calendar-lesson-plan col-12 col-sm-6 col-md-4 col-lg-3"
          *ngSwitchCase="CalendarView.Day"
          [viewDate]="viewDate"
          [refresh]="refresh"
          [events]="lessonPlanEvents"
          [eventTemplate]="dayEventTemplate"
          (beforeViewRender)="beforeDayViewRender($event)"
          [hourSegments]="4"
          [dayStartHour]="startHour"
          [dayEndHour]="endHour"
        >
        </mwl-calendar-day-view>
      </div>
    </div>
  </div>
</div>

<!-- day event template -->
<ng-template #dayEventTemplate let-weekEvent="weekEvent" let-locale="locale">
  <div
    class="d-flex day-event row"
    [ngClass]="{
      'current-event': weekEvent.event?.classroom_id === classroom.id,
      'event-passed': weekEvent?.event?.start?.getTime() < currentDate?.getTime(),
      'event-remain': weekEvent?.event?.start?.getTime() >= currentDate?.getTime(),
      'dark-theme': analyticsService?.currentTheme === 'material-dark'
    }"
    (click)="openEventLessonPlanModal($event, weekEvent.event)"
  >
    <!-- (click)="openEventLessonPlanModal($event, weekEvent.event)" -->
    <!-- <div class="col-md-12 event-content text-left d-flex"> -->
    <div class="col-12 p-0">
      <!-- <div class="section-number-label section-id-content-label">
        <label class="event-content-label dark-mode-label"
          >Section Id 2:
        </label>
        <label class="event-content-label ml-1 dark-mode-label">
          <span *ngIf="weekEvent?.event?.lesson_plan_id !== 0">
            {{
              weekEvent?.event?.lesson_plan?.pacing_plan_id[0]?.section_id
                ? weekEvent?.event?.lesson_plan?.pacing_plan_id[0]?.section_id
                : weekEvent?.event?.lesson_plan?.teacher_custom_pacing_plans
                ? weekEvent?.event?.lesson_plan?.teacher_custom_pacing_plans?.section_id
                : weekEvent?.event?.lesson_plan?.custom_global_pacing_plan
                ? weekEvent?.event?.lesson_plan?.custom_global_pacing_plan?.section_id
                : '-'
            }}
          </span>
          <span *ngIf="weekEvent?.event?.lesson_plan_id === 0">
            {{ weekEvent?.event?.lesson_plan?.section_id }}
          </span>
        </label>
      </div> -->

      <div class="row">
        <div class="col-9 section-number-label">
          <div
            class="section-number-label"
            [ngClass]="{
          'current-event-label': weekEvent.event?.classroom_id === classroom.id,
          'event-passed-label':
            weekEvent?.event?.start?.getTime() < currentDate?.getTime(),
          'event-remain-label':
            weekEvent?.event?.start?.getTime() >= currentDate?.getTime(),
        }"
          >
            <label class="event-content-label subject-grade-label"
              ><span *ngIf="weekEvent?.event?.lesson_plan_id !== 0">
                {{
              (weekEvent?.event?.lesson_plan?.pacing_plan_id?.[0] ?? weekEvent?.event?.lesson_plan?.teacher_custom_pacing_plans_id?.[0] ?? weekEvent?.event?.lesson_plan?.custom_global_pacing_plan?.[0])?.grades?.grade || null
                }}
              </span>
              <span> {{ weekEvent?.event?.lesson_plan?.grade }} </span>
            </label>
            <label class="event-content-label subject-grade-label ml-1"
              ><span *ngIf="weekEvent?.event?.lesson_plan_id !== 0">
                {{
              (weekEvent?.event ?? weekEvent?.event?.lesson_plan?.teacher_custom_pacing_plans_id?.[0] ?? weekEvent?.event?.lesson_plan?.custom_global_pacing_plan?.[0])?.subject?.subject || null
                }}
              </span>
              <span *ngIf="weekEvent.event.lesson_plan_id === 0">
                {{ weekEvent?.event?.lesson_plan?.subject }}
              </span>
            </label>
          </div>
          <div *ngFor="let plan of getPlans(weekEvent?.event?.lesson_plan)">
            <div class="section-info" *ngIf="plan">
              <span class="event-content-label ml-1 dark-mode-label mb-0 mr-2">
                {{ plan?.section_id || '-' }}
              </span>
              <span>-</span>
              <span
                class="event-content-label ml-1 dark-mode-label mb-0 ellipsis"
                matTooltip="{{ plan?.section_title || '-' }}"
                matTooltipPosition="above"
              >
                {{ plan?.section_title || '-' }}
              </span>
            </div>
          </div>

          <div *ngIf="classroom?.user_id === user?.id && weekEvent?.event?.substitute_teacher_user_id > 0">
            <img
              height="25"
              width="25"
              src="/assets/icons/ic-substitute.svg"
              title="Lesson plan added by substitute teacher"
              alt="substitute-teacher-img"
              class="mr-2"
            />
          </div>
          <div class="d-flex flex-wrap">
            <ng-container *ngIf="weekEvent?.event?.updates[10]?.title">
              <span class="event-content-label ml-1 section-title-label dark-mode-label"> Title: </span>
              <span class="event-content-label ml-1 mr-1 dark-mode-label">
                <span>{{ weekEvent?.event?.updates[10]?.title }}</span>
              </span>
            </ng-container>

            <ng-container *ngIf="weekEvent?.event?.updates[11]?.author">
              <span class="event-content-label ml-1 section-title-label dark-mode-label"> Author: </span>
              <span class="event-content-label ml-1 mr-1 dark-mode-label">
                <span>{{ weekEvent?.event?.updates[11]?.author }}</span>
              </span>
            </ng-container>

            <ng-container *ngIf="weekEvent?.event?.updates[12]?.chapter">
              <span class="event-content-label ml-1 section-title-label dark-mode-label"> Chapter: </span>
              <span class="event-content-label ml-1 dark-mode-label">
                <span>{{ weekEvent?.event?.updates[12]?.chapter }}</span>
              </span>
            </ng-container>
          </div>

          <!-- <div class="d-flex">
            <label class="event-content-label section-title-label dark-mode-label" *ngIf="weekEvent?.event?.updates[10]?.title"
              >Title:
            </label>
            <label class="event-content-label ml-1 mr-3 dark-mode-label" *ngIf="weekEvent?.event?.updates[10]?.title">
              <span>
                {{ weekEvent?.event?.updates[10]?.title }}
              </span>
            </label>
            <label class="event-content-label section-title-label dark-mode-label" *ngIf="weekEvent?.event?.updates[11]?.author"
              >Author:
            </label>
            <label class="event-content-label ml-1 mr-3 dark-mode-label" *ngIf="weekEvent?.event?.updates[11]?.author">
              <span>
                {{ weekEvent?.event?.updates[11]?.author }}
              </span>
            </label>
            <label class="event-content-label section-title-label dark-mode-label" *ngIf="weekEvent?.event?.updates[12]?.chapter"
              >Chapter:
            </label>
            <label class="event-content-label ml-1 dark-mode-label" *ngIf="weekEvent?.event?.updates[12]?.chapter">
              <span> {{ weekEvent?.event?.updates[12]?.chapter }} </span>
            </label>
          </div> -->
        </div>

        <div class="col-3 button-container">
          <!-- <nb-icon icon="eye-outline" title="VIEW FULL LESSON" class="view-lesson-plan-ic" *ngIf="lessonPlanEvents.length > 4"></nb-icon> -->
          <button
            nbButton
            class="lesson-plan-event-push mt-2 ml-1"
            (click)="openEventLessonPlanModal($event, weekEvent.event)"
            [ngClass]="lessonPlanEvents.length >= 6 ? 'button-view' : ''"
          >
            View
          </button>
          <button
            nbButton
            data-child="true"
            class="lesson-plan-event-push push-button ml-1 mt-1"
            *ngIf="
              !teacherId &&
              weekEvent?.event?.subject_id === classroom?.current_subject_id &&
              weekEvent?.event?.grades_id === classroom?.grades_id &&
              weekEvent.event?.classroom_id === classroom.id
            "
            (click)="openSelectReasonDialog(weekEvent.event)"
            [ngClass]="lessonPlanEvents.length >= 6 ? 'button-view' : ''"
          >
            Push
          </button>
        </div>
      </div>

      <!-- <div class="d-flex">
        <label class="event-content-label section-title-label dark-mode-label"
          >Title:
        </label>
        <label class="event-content-label main-label ml-1 dark-mode-label">
          <span *ngIf="weekEvent.event.lesson_plan_id !== 0">
            {{
              weekEvent.event.lesson_plan?.pacing_plan?.section_title
                ? weekEvent.event.lesson_plan?.pacing_plan?.section_title
                : weekEvent.event.lesson_plan?.teacher_custom_pacing_plans
                ? weekEvent?.event?.lesson_plan?.teacher_custom_pacing_plans?.section_title
                : weekEvent?.event?.lesson_plan?.custom_global_pacing_plan?.section_title
            }}
          </span>
          <span *ngIf="weekEvent.event.lesson_plan_id === 0">
            {{ weekEvent.event.lesson_plan.section_title }}
          </span>
        </label>
      </div> -->
    </div>

    <!-- <div style="position: absolute; right: 10px">
      <nb-icon icon="eye-outline" title="VIEW FULL LESSON" class="view-lesson-plan-ic"></nb-icon>
    </div>
    <div style="right: 10px">
      <br />
      <button
        nbButton
        data-child="true"
        class="lesson-plan-event-push"
        (click)="openSelectReasonDialog(weekEvent.event)"
        *ngIf="
          !teacherId &&
          weekEvent?.event?.subject_id === classroom?.current_subject_id &&
          weekEvent?.event?.grades_id === classroom?.grades_id &&
          weekEvent.event?.classroom_id === classroom.id
        "
      >
        Push
      </button>
    </div> -->
    <!-- </div> -->
  </div>
</ng-template>

<!-- push selection choice dialog -->
<ng-template #pushLessonPlanDialog let-ref="dialogRef">
  <div class="create-new-plan-modal" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="create-pushed-lesson-plan add-classroom-modal assignment-modal">
      <div class="modal-header align-items-center d-flex w-100 justify-content-between" *ngIf="!isNewAdd">
        <div class="lesson-plan-time">
          {{ currentLessonPlan?.start | date : 'h:mm a' }} -
          {{ currentLessonPlan?.end | date : 'h:mm a' }}
        </div>

        <div>
          <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="closeDialogOfReason()">
            <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
          </span>
        </div>
      </div>

      <div *ngIf="isNewAdd" class="d-flex justify-content-between create-new-lesson-plan-header align-items-center modal-header">
        <div class="d-flex align-items-center">
          <span class="icon-add-classroom">
            <nb-icon icon="plus-outline"></nb-icon>
          </span>
          <h6 class="add-clasroom-text quicksand-bold-label m-0">Create New Lesson Plan</h6>
        </div>
        <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="closeDialogOfReason()">
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </div>

      <div class="form-group modal-body" *ngIf="isNewAdd">
        <form [formGroup]="addLessonPlanForm">
          <div class="mb-2">
            <label class="label form-control-label quicksand-normal-label">Choose type </label>
            <br />

            <nb-radio-group
              name="multiple-schools-management-privileges-radio-group"
              formControlName="standard_type"
              class="d-flex bell-schedule-radio"
            >
              <nb-radio value="true"> Select standard </nb-radio>
              <nb-radio value="false"> Custom standard </nb-radio>
            </nb-radio-group>
          </div>
        </form>
        <div *ngIf="addLessonPlanForm?.value?.standard_type === 'true'">
          <label class="quicksand-bold-label">Select Section Id <span class="required-field">*</span></label>
          <mat-select placeholder="Select Section Id" [(ngModel)]="sectionId" class="w-100 select-section">
            <mat-option
              class="select-section-id quicksand-bold-label select-range"
              *ngFor="let pacingPlan of pacingPlanEvents"
              [value]="pacingPlan"
            >
              <div style="min-height: 30px; font-size: 14px">
                <label class="quicksand-normal-label">Section Id:</label>
                {{ pacingPlan?.section_id ? pacingPlan?.section_id : '-' }}
              </div>

              <div style="min-height: 30px; white-space: pre-line; line-height: 12px; font-size: 14px">
                <label class="quicksand-normal-label">Section Title:</label>
                {{ pacingPlan?.section_title }}
              </div>
            </mat-option>
          </mat-select>
        </div>
        <div *ngIf="addLessonPlanForm?.value?.standard_type === 'false'">
          <div class="mt-2 my-2 create-custom-standard">
            <div class="mt-1">
              <label class="quicksand-bold-label">Use a custom standards <span class="required-field">*</span></label>
            </div>
            <div class="d-flex">
              <textarea
                class="nb-input auto-resize-textarea standard"
                nbInput
                fullWidth
                placeholder="Type any standard or concept to teach"
                [(ngModel)]="standard"
                (ngModelChange)="onTextAreaChange()"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          nbButton
          class="quicksand-bold-label w-100 text-capitalize create-lesson modal-footer"
          [disabled]="
            (addLessonPlanForm?.value?.standard_type === 'true' && !sectionId) ||
            (addLessonPlanForm?.value?.standard_type === 'false' && (!standard || standard.trim() === '')) ||
            !addLessonPlanForm?.value?.standard_type
          "
          (click)="addLessonPlanForm?.value?.standard_type === 'true' ? getTeacherLessonPlanByAI() : getTeacherLessonPlanByAI(standard)"
        >
          Create Lesson Plan
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #selectSubjectDialog let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="text-center">
        <h6 class="text-center quicksand-bold-label">
          Please Enter reason why do you want
          <br />
          to push current
          {{ currentPushPlan === 'pacing-plan' ? 'Pacing' : 'Lesson' }} plan?
        </h6>
        <label class="quicksand-normal-label reason-label"
          >(This will also push {{ currentPushPlan === 'pacing-plan' ? 'Lesson' : 'Pacing' }} plans
          <br />
          related to respective
          {{ currentPushPlan === 'pacing-plan' ? 'Pacing' : 'Lesson' }}
          plan)</label
        >
      </div>

      <div class="form-group mt-2">
        <mat-select class="w-100 select-section-id h-auto" (selectionChange)="changeReason($event?.value)" placeholder="Select Your Reason">
          <mat-option *ngFor="let reason of pacingPlanReasons" [value]="reason" class="quicksand-bold-label select-range select-reason">
            {{ reason }}
          </mat-option>
        </mat-select>
      </div>

      <div class="d-flex" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
        <button nbButton class="delete-lesson-plan m-2 w-100 cancel-button" (click)="closeDialogOfReason()">Cancel</button>
        <button
          *ngIf="selectedPushLessonPlanEventReason === 'Reteach Yesterday’s Standard'"
          mat-raised-button
          class="push-lesson-plan m-2 w-100 push-modal-button"
          title="Push current pacing event to next day"
          (click)="pushDateToNext()"
        >
          Push
        </button>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>

<!-- dialogue for delete lesson event -->
<ng-template #dialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="text-center">
        <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
        <br />

        <label class="label-delete-lesson-plan mt-1">Delete Lesson Plan</label>
        <br />
        <label class="delete-lesson-plan-confirmation">Are you sure want to delete this lesson plan ?</label>
      </div>
      <div class="d-flex">
        <button nbButton class="delete-lesson-plan bg-white m-2 w-100" (click)="ref.close()">Cancel</button>
        <button nbButton color="warn" class="delete-lesson-plan delete m-2 w-100" (click)="deleteLessonPlan()">Delete</button>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>

<!-- add new Lesson Plan modal -->

<ng-template #lessonPlanModal>
  <div
    class="custom-overlay-container ai-lesson-plan-dialog"
    [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
  >
    <div class="add-classroom-modal ai-generated-lesson-plan-modal">
      <div class="modal-header d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <span class="icon-add-classroom">
            <nb-icon icon="plus-outline"></nb-icon>
          </span>
          <h6 class="add-clasroom-text quicksand-bold-label m-0">AI-Generated Lesson Plan</h6>
        </div>

        <span
          class="icon-close-classroom-modal d-block cursor-pointer"
          (click)="
            closeDialogOfReason();
            currentPacingPlanIdToPush = 0;
            lessonPlanForm.reset();
            analyticsService?.trackEvent('Lesson Plan Modal', 'Classroom Dashboard Lesson Plan')
          "
        >
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </div>

      <div class="modal-body p-0">
        <div class="lesson-plan-modal" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
          <label class="quicksand-normal-label label-lesson-plan"
            >Please confirm that the details of this AI-generated lesson plan are correct. If not, click "Cancel" below and try creating it
            once more for a more suitable result. Then, click "Save".</label
          >

          <form [formGroup]="lessonPlanForm">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label">Objective:</label>
                  <textarea
                    placeholder="Objective"
                    formControlName="objective"
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    class="w-100 text-area"
                  ></textarea>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label">Anticipatory Set:</label>
                  <textarea
                    formControlName="anticipatory_set"
                    placeholder="Anticipatory Set"
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    class="w-100 text-area"
                  ></textarea>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label">Presentation:</label>
                  <div *ngIf="!isEditing; else editMode">
                    <div
                      class="math-output"
                      contenteditable="true"
                      [mathjax]="getFormattedAnswer('presentation')"
                      (input)="isEditing = true"
                    ></div>
                  </div>

                  <ng-template #editMode>
                    <textarea
                      formControlName="presentation"
                      placeholder="Presentation"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      class="w-100 text-area"
                    ></textarea>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label">Guided Practice Questions:</label>
                  <div *ngIf="!isEditing; else editMode">
                    <div
                      class="math-output"
                      contenteditable="true"
                      [mathjax]="getFormattedAnswer('guided_practice_questions')"
                      (input)="isEditing = true"
                    ></div>
                  </div>

                  <ng-template #editMode>
                    <textarea
                      formControlName="guided_practice_questions"
                      placeholder="Guided Practice Questions"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      class="w-100 text-area"
                    ></textarea>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label">Homework Questions:</label>

                  <div *ngIf="!isEditing; else editMode">
                    <div
                      class="math-output"
                      contenteditable="true"
                      [mathjax]="getFormattedAnswer('homework_questions')"
                      (input)="isEditing = true"
                    ></div>
                  </div>

                  <ng-template #editMode>
                    <textarea
                      formControlName="homework_questions"
                      placeholder="Homework Questions"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      class="w-100 text-area"
                    ></textarea>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="label form-control-label">Closure:</label>

                  <textarea
                    placeholder="Closure"
                    formControlName="closure"
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    class="w-100 text-area"
                  ></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-end">
        <button
          nbButton
          (click)="
            closeDialogOfReason();
            currentPacingPlanIdToPush = 0;
            lessonPlanForm.reset();
            analyticsService?.trackEvent('Lesson Plan Modal', 'Classroom Dashboard Lesson Plan')
          "
          class="quicksand-bold-label text-capitalize btn-cancel mr-2"
        >
          Cancel
        </button>
        <button nbButton (click)="addCurrentLessonPlanAndRender()" class="quicksand-bold-label text-capitalize btn-save save-lesson-plan">
          Save
        </button>
      </div>
    </div>
  </div>
</ng-template>
